import React, { createContext, useContext, useState } from 'react';

const SettingsContext = createContext();

const DEFAULTS = {
  numDiagnoses: 3,
  reportTemplate: 'standard',
  sessionRetentionDays: 180,
};

function loadSettings() {
  try {
    const stored = localStorage.getItem('caisar-settings');
    return stored ? { ...DEFAULTS, ...JSON.parse(stored) } : DEFAULTS;
  } catch {
    return DEFAULTS;
  }
}

export function SettingsProvider({ children }) {
  const [settings, setSettingsState] = useState(loadSettings);

  const updateSettings = (updates) => {
    setSettingsState((prev) => {
      const next = { ...prev, ...updates };
      localStorage.setItem('caisar-settings', JSON.stringify(next));
      return next;
    });
  };

  return (
    <SettingsContext.Provider value={{ settings, updateSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
